import { useCalendarEventViewModalStore } from '@forwardflow/store/modal'
import { Button, UserAvatar } from '@forwardflow/ui'
import Icon from '@forwardflow/ui/Icons'
import { Modal } from 'antd'
import dayjs from 'dayjs'

interface CalendarEventViewModalProps {
   selectedEvent: any
}

export const CalendarEventViewModal: React.FC<CalendarEventViewModalProps> = ({
   selectedEvent,
}) => {
   const { isCalendarViewModalOpen, closeCalendarViewModal } =
      useCalendarEventViewModalStore()
   return (
      <>
         <Modal
            open={isCalendarViewModalOpen}
            onCancel={closeCalendarViewModal}
            footer={null}
            className="p-0 ff-modal !w-[650px] grayscale-[1] blur-[2px]"
         >
            {selectedEvent && (
               <div className="mx-auto text-white rounded-lg">
                  <div className="flex items-center px-12 py-8 text-lg font-medium">
                     <span className="text-[#7E7E7E]">Calendar</span>
                     <Icon name="arrow-down" className="px-3 -rotate-90" />
                     <span>
                        {selectedEvent.extendedProps?.client} meeting with{' '}
                        {selectedEvent.extendedProps?.agent}
                     </span>
                  </div>

                  <div className="flex flex-col gap-4 bg-[#323338]/50 px-12 py-4">
                     <div className="flex items-center gap-4">
                        <UserAvatar></UserAvatar>
                        <div>
                           <div className="font-semibold">
                              {selectedEvent.extendedProps?.agent}
                           </div>
                           <div className="text-[#BBB] text-[14px]">Agent</div>
                        </div>
                        <div className="flex items-center gap-1 ml-auto">
                           <Icon name="Call" className="px-3 fill-[#7E7E7E]" />
                           <div className="ml-auto text-gray-400">
                              (206) 342-8631
                           </div>
                        </div>
                     </div>

                     <div className="flex justify-between pt-3 text-gray-400 border-t border-white/10">
                        <div className="flex items-center gap-3">
                           <div>Total Appointments</div>
                           <div className="text-2xl text-white">36</div>
                        </div>
                        <div className="flex items-center gap-3">
                           <div>Today</div>
                           <div className="text-2xl text-white">1</div>
                        </div>
                        <div className="flex items-center gap-3">
                           <div>This week</div>
                           <div className="text-2xl text-white">6</div>
                        </div>
                     </div>
                  </div>

                  <div className="px-12 py-8">
                     <div className="text-[12px] font-medium text-[#BBB]">
                        Meeting with
                     </div>
                     <div className="flex items-center mt-2">
                        <span className="font-medium">James Anderson</span>
                        <span className="px-2 py-1 text-xs rounded-full bg-white/5 text-[#8BB2EE] ml-auto">
                           Buyer
                        </span>
                        <span className="px-2 py-1 ml-2 text-xs font-medium rounded-full bg-primary/20">
                           zillow
                        </span>
                        <div className="flex items-center gap-3 ml-7 text-[#BBB]">
                           <Icon name="Call" className="fill-[#7E7E7E]" />
                           <span>(206) 342-8631</span>
                        </div>
                     </div>

                     <div className="flex items-center justify-between pt-4 mt-5 text-[#BBB] border-t border-white/10">
                        <div>
                           Time: {dayjs(selectedEvent.start).format('h:mm a')} -{' '}
                           {dayjs(selectedEvent.end).format('h:mm a')}, 18
                           October, Friday
                        </div>
                        <div>Place: Google meet</div>
                     </div>
                  </div>

                  <div className="px-12 py-6 border-t border-white/10">
                     <div className="text-[12px] font-medium text-white/70">
                        Buyer Summary
                     </div>
                     <div className="mt-5">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                        sed do eiusmod tempor incididunt ut labore et dolore
                        magna.
                     </div>
                  </div>

                  <div className="flex items-center justify-between px-12 py-6 border-t border-white/10">
                     <button
                        onClick={closeCalendarViewModal}
                        className="text-[14px] cursor-pointer"
                     >
                        Close
                     </button>
                     <Button className="!mt-0 max-w-56 !rounded-lg">
                        View Conversation
                     </Button>
                  </div>
               </div>
            )}
         </Modal>
      </>
   )
}
